import type { FaireProductEntity } from "../../entity_types/product";

export const p_tcmx6cut6w: FaireProductEntity = {
  token: "p_tcmx6cut6w",
  type: "product",
  name: "Host Doing The Most Holiday Card",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/a898f4709dcd04bb7cfff1670f0a9aad50427fbdaa3bfb9bacd26ff7e6be9a44.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ba4b0178addd778603f9066fa899033887fdc8384729f575904e37727057181.jpeg",
    "https://cdn.faire.com/fastly/c0c831ac96caab5005618198708f3884700380bac582761167ae41eb0d2ec7b7.jpeg"
  ],
  priceDollars: 2.75,
  description: "A cheerful, thoughtful way to say thanks for the invite. Our Host Doing the Most Greeting Card is made for the friend who sets the table, lights the candles, and makes it all look effortless. Perfect for holiday parties, dinner hosts, or anyone who deserves a little extra appreciation.\n\nGood to know: \n\n * Blank on the inside \n * A2 (4.25 inches by 5.5 inches) *New size! \n\n * Includes red envelope \n * Individually wrapped in a cellophane sleeve or plastic free with card clasp. ",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:10.633Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
